
/**
 * Module dependencies.
 */

import { Component } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

/**
 * `Props` type.
 */

type Props = RouteComponentProps & {
  location: {
    hash: string;
    pathname: string;
    search: string;
    state?: any;
  };
};

/**
 * `ScrollRestoration` component.
 */

class ScrollRestoration extends Component<Props> {

  /**
   * Component did update.
   */

  componentDidUpdate({ location: previousLocation }: Props) {
    const { location } = this.props;
    const noRestoration = location?.state?.noRestoration;

    if (location !== previousLocation && !noRestoration) {
      window.scrollTo(0, 0);
    }
  }

  /**
   * Render.
   */

  render(): null {
    return null;
  }

}

/**
 * Export `ScrollRestoration` component.
 */

export default withRouter(ScrollRestoration);
